import React, { useState, useEffect, useRef } from "react";
import {
  LoaderWrapper,
  CsplTable as Table,
  ManageCensusLayout,
  Link,
  FieldButtonGroup,
  FieldInput,
  SliderPanel,
  AddPlans,
  WarningModal,
  FieldInputDollar,
  FieldInputPercentage,
  FormControlSearch,
  WarningInfoModal,
} from "../../../components";
import {
  getAdvancedPathWithParam,
  FLOW_TYPES,
  MANAGE_CENSUS_ROUTES,
  manageCensusFormNames,
  yesNoOptions,
  returnOnlyIfBoolean,
  formFields,
} from "../../../utils";
import { useRouterParams, useRequest, useDeepEffect } from "../../../abstracts";
import { Formik, Field, FieldArray } from "formik";
import { Form, Button, InputGroup, Image } from "react-bootstrap";
import {
  getDefaultElectionSetting,
  getPlanSourceInformation,
  getPlanInvestments,
  getEmployeeEnrollment,
  saveEnrollment,
  optOutPlan,
} from "../../../services";
import { get, isEmpty, flatMap } from "lodash";
import { faPencilAlt, faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation } from "react-router-dom";
import axios from "axios";

const ManualEnrollmentContainer = (props) => {
  const { history } = props;
  const [newFlow, setNewFlow] = useState("");
  const { censusId, flow, planId } = useRouterParams();
  const search = useLocation().search;
  const name = new URLSearchParams(search).get("name");
  const planName = name?.replace("%", " ");
  const formName = manageCensusFormNames.MANUAL_ENROLLMENT;
  const fields = formFields[formName];
  const [isModalOpen, setModalOpen] = useState(false);
  let [filteredResponse, setFilteredResponse] = useState([]);
  const [addedInvestments, setAddedInvestments] = useState({ 0: [] });
  const [searchString, setSearchString] = useState("");
  const [saveInvestments, setSaveInvestments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sourceInd, setSourceInd] = useState(0);
  const isEdit = flow === FLOW_TYPES.EDIT;
  const isSave = newFlow === FLOW_TYPES.SAVE;
  const doesAllSourcesFollowSameElection = useRef();
  const [
    getParticipantEnrollmentInfo,
    setGetParticipantEnrollmentInfo,
  ] = useState({});
  const [sourcesList, setSourcesList] = useState([]);
  let source = axios.CancelToken.source();
  const { response: investmentList } = useRequest({
    method: getPlanInvestments,
    payload: planId,
    defaultResponse: [],
  });
  const [getIsOptOutAccess, setIsOptOutAccess] = useState({});
  const [getIsOptedOut, setIsOptedOut] = useState({});
  // const { response: sourcesList } = useRequest({
  //   method: getPlanSourceInformation,
  //   payload: planId,
  // });

  const { response: getDefaultElection } = useRequest({
    method: getDefaultElectionSetting,
    payload: planId,
  });
  const [modalVisible, setModalVisible] = useState(false);
  const closeModal = () => {
    setModalVisible(false);
  };
  const [warningVisible, setWarningVisible] = useState(false);
  const closeWarning = () => {
    setWarningVisible(false);
  };

  // const { response: getParticipantEnrollmentInfo } = useRequest({
  //   method: getEnrollment,
  //   payload: { planId: planId, employeeId: censusId },
  // });
  useEffect(() => {
    setLoading(true);
    getEmployeeEnrollment(
      { planId: planId, employeeId: censusId },
      source.token
    )
      .then((response) => {
        setLoading(false);
        setIsOptOutAccess(response.isOptOutAccess);
        setIsOptedOut(response.isOptedOut);
        setGetParticipantEnrollmentInfo(response.employeePlanMap);
        if (
          response.employeePlanMap.useDefaultAllocation != null &&
          !response.employeePlanMap.useDefaultAllocation &&
          response.employeePlanMap.doesAllSourcesFollowSameElection != null &&
          response.employeePlanMap.doesAllSourcesFollowSameElection
        ) {
          setSaveInvestments(response.employeePlanMap.electedInvestments);
        }
      })
      .catch((ex) => setLoading(false));
    getPlanSourceInformation(planId, source.token).then((response) => {
      setSourcesList(
        response.filter((team) => {
          return team.sourceCategory !== 4;
        })
      );
    });
    return () => {
      source.cancel("cancelled");
    };
  }, []);

  const displayType = (amt, cont, number) => {
    let res;
    if (cont === "Dollar")
      res =
        number === 0
          ? "Minimum amount " + "$" + amt
          : "Maximum amount " + "$" + amt;
    else
      res =
        number === 0
          ? "Minimum percentage " + amt + "%"
          : "Maximum percentage " + amt + "%";
    return res;
  };

  const columns = [
    {
      label: "Investment",
      className: "column-investment",
      columnName: "investmentName",
    },
    {
      label: "Percentage",
      className: "column-percentage",
      columnName: "percentage",
    },
  ];

  const addInvestmentsAndSourceIdToPlan = (name) => {
    setAddedInvestments((e) => ({
      ...e,
      [sourceInd]: e[sourceInd] ? [...e[sourceInd], name] : [name],
    }));
  };

  const onViewButtonClick = () => {
    setModalOpen(true);
  };
  const Invsum = () => {
    let sum1 = 0;
    get(getDefaultElection, "investmentDetails", []).map((source) => {
      sum1 = sum1 + source.investmentPercentage;
    });
    return sum1;
  };

  useDeepEffect(() => {
    if (sourceInd === undefined || sourceInd === null) return;
    setFilteredResponse({
      ...filteredResponse,
      [sourceInd]: investmentList.filter((team) => {
        return team.investmentName
          ?.toLowerCase()
          .includes(searchString.toLowerCase());
      }),
    });
  }, [searchString, investmentList]);

  useEffect(() => {
    filteredResponse = {};
    if (doesAllSourcesFollowSameElection.current == false) {
      sourcesList.forEach((x, i) => {
        filteredResponse[i] = investmentList.map((y) => ({
          ...y,
          sourceId: x.sourceId,
        }));
      });
      setFilteredResponse(filteredResponse);
      return;
    }
    setFilteredResponse({
      [sourceInd]: investmentList.filter((team) => {
        return team.investmentName
          ?.toLowerCase()
          .includes(searchString.toLowerCase());
      }),
    });
  }, [doesAllSourcesFollowSameElection.current]);
  // to set the added Investments
  useDeepEffect(
    () => {
      if (isEmpty(getParticipantEnrollmentInfo) || isEmpty(sourcesList)) return;
      if (
        getParticipantEnrollmentInfo.useDefaultAllocation != null &&
        getParticipantEnrollmentInfo.useDefaultAllocation == true
      )
        return;
      if (
        getParticipantEnrollmentInfo.doesAllSourcesFollowSameElection &&
        getParticipantEnrollmentInfo.doesAllSourcesFollowSameElection == true
      ) {
        setAddedInvestments({
          [sourceInd]: getParticipantEnrollmentInfo.electedInvestments,
        });
        return;
      }
      setAddedInvestments(
        setSourceWiseInvestmentsInformation(getParticipantEnrollmentInfo)
      );
    },
    [getParticipantEnrollmentInfo, sourcesList],
    true
  );

  const getElectedInvestments = (es, values) => {
    if (values["useDefaultAllocation"] == true)
      return getDefaultElection.investmentDetails.map((_) => {
        return { ..._, allocationPercentage: _.investmentPercentage };
      });
    // else {
    else if (values.doesAllSourcesFollowSameElection == true) {
      return values.sameSourcesInvestmentElection;
    }
    return flatMap(Object.values(values.sourceWiseInvestments));
  };
  const getEnrolledSources = (values) => {
    if (
      isEmpty(getDefaultElection.sourceList) ||
      getDefaultElection.sourceList == undefined
    ) {
      return values["enrolledSources"];
    } else {
      return getDefaultElection.sourceList.map((e) => {
        var source = values["enrolledSources"]?.find(
          (x) => x.sourceName === e.sourceName
        );
        return source ? source : e;
      });
    }
  };
  const formSubmit = (
    values,
    { setFieldError, setErrors, setFieldTouched }
  ) => {
    var errorValues = {};
    if (
      values?.useDefaultAllocation === false &&
      values?.doesAllSourcesFollowSameElection === true &&
      values.sameSourcesInvestmentElection.length === 0
    ) {
      errorValues["sameElectionInvestment"] = `Required`;
    }
    let errorsSourceWise = {};
    if (
      values?.useDefaultAllocation === false &&
      values?.doesAllSourcesFollowSameElection === false
    ) {
      sourcesList.map((e, i) => {
        if (get(values, `sourceWiseInvestments.${i}`, []).length === 0) {
          errorValues["differentElectionInvestment"] = get(
            errorValues,
            "differentElectionInvestment",
            {}
          );
          errorValues["differentElectionInvestment"][i] = "Required";
        }
      });
    }
    setErrors(errorValues);
    if (isEmpty(errorValues)) {
      var enrollmentData = {
        id: get(values, "id", 0),
        employeeId: parseInt(censusId, 10),
        planId: parseInt(planId, 10),
        //enrollmentData: get(formValues, "enrollmentData", null),
        useDefaultElection: get(values, fields.useDefaultElection, true),
        useDefaultAllocation: get(values, fields.useDefaultAllocation, true),
        autoDeferralIncease: get(values, fields.autoDeferralIncrease, false),
        doesAllSourcesFollowSameElection: get(
          values,
          fields.doesAllSourcesFollowSameElection,
          true
        ),
        enrollmentMode: 1,
        electedInvestments: getElectedInvestments({}, values),
        enrolledSources: getEnrolledSources(values),
      };
      setLoading(true);
      saveEnrollment(enrollmentData)
        .then((res) => {
          var enrolledSourcesErrors = 0;
          for (var i = 0; i < res.employeePlanMap.enrolledSources.length; i++) {
            var j = 0;
            if (
              res.employeePlanMap.enrolledSources[i].errorMessages.length > 0
            ) {
              enrolledSourcesErrors = enrolledSourcesErrors + 1;
            }
          }
          if (
            res.employeePlanMap.errorMessages.length === 0 &&
            enrolledSourcesErrors === 0
          ) {
            setLoading(false);
            setNewFlow(FLOW_TYPES.EDIT);
            setIsOptOutAccess(res.isOptOutAccess);
            setIsOptedOut(res.isOptedOut);
            setGetParticipantEnrollmentInfo(res.employeePlanMap);
          } else {
            for (var i = 0; i < res.employeePlanMap.errorMessages.length; i++) {
              var _ = res.employeePlanMap.errorMessages[i];
              setFieldTouched(_.controlName, true);
              setFieldError(
                _.controlName,
                `${_.errorCode} : ${_.errorMessage}`
              );
            }
            if (
              res.employeePlanMap.useDefaultElection !== null &&
              res.employeePlanMap.useDefaultElection === false
            ) {
              for (
                var i = 0;
                i < res.employeePlanMap.enrolledSources.length;
                i++
              ) {
                var j = 0;
                if (
                  res.employeePlanMap.enrolledSources[i].errorMessages.length >
                  0
                ) {
                  var _ =
                    res.employeePlanMap.enrolledSources[i].errorMessages[j];
                  setFieldTouched(`enrolledSources[${i}].election`, true);
                  setFieldError(
                    `enrolledSources[${i}].election`,
                    `${_.errorCode} : ${_.errorMessage}`
                  );
                }
              }
            }
            setLoading(false);
          }
        })
        .catch(() => {
          setLoading(false);
        });
    }
  };
  const setSourceWiseInvestmentsInformation = (
    getParticipantEnrollmentInfo
  ) => {
    if (
      !isEmpty(getParticipantEnrollmentInfo) &&
      getParticipantEnrollmentInfo.useDefaultAllocation != null &&
      !getParticipantEnrollmentInfo.useDefaultAllocation &&
      getParticipantEnrollmentInfo.doesAllSourcesFollowSameElection != null &&
      !getParticipantEnrollmentInfo.doesAllSourcesFollowSameElection
    ) {
      const sourArr = {};
      for (const investment of getParticipantEnrollmentInfo.electedInvestments) {
        const ind = sourcesList.findIndex(
          (x) => x.sourceId == investment.sourceId
        );
        sourArr[ind] = sourArr[ind]
          ? [...sourArr[ind], investment]
          : [investment];
      }
      return sourArr;
    }
    return getParticipantEnrollmentInfo.electedInvestments != null
      ? getParticipantEnrollmentInfo.electedInvestments
      : [];
  };

  const onOptClick = () => {
    setModalVisible(false);
    optOutPlan(planId, censusId)
      .then((res) => {
        if (res === true) {
          setIsOptedOut(true);
        } else {
          setWarningVisible(true);
        }
        // setLoading(false);
        // setNewFlow(FLOW_TYPES.EDIT);
      })
      .catch(() => {
        // setLoading(false);
      });
  };

  const enrolledSourcesInitialValues =
    !isEmpty(getParticipantEnrollmentInfo) &&
    getParticipantEnrollmentInfo.enrolledSources != null
      ? getParticipantEnrollmentInfo.enrolledSources.map((_) => {
          var source = sourcesList.find((s) => s.sourceId === _.sourceId);
          return {
            ..._,
            limitMaximumDollar: source?.limitMaximumDollar,
            limitMinimumDollar: source?.limitMinimumDollar,
            contributionType: source?.contributionType,
          };
        })
      : sourcesList
          .filter((x) => x.sourceType == 1)
          .map((_) => {
            return {
              ..._,
              election: get(getDefaultElection, "sourceList", []).find(
                (i) => i.sourceContributionId === _.sourceId
              )?.contributionRate,
            };
          });

  return (
    <div>
      <Formik
        initialValues={{
          sameSourcesInvestmentElection:
            !isEmpty(getParticipantEnrollmentInfo) &&
            getParticipantEnrollmentInfo.useDefaultAllocation != null &&
            !getParticipantEnrollmentInfo.useDefaultAllocation &&
            getParticipantEnrollmentInfo.doesAllSourcesFollowSameElection !=
              null &&
            getParticipantEnrollmentInfo.doesAllSourcesFollowSameElection
              ? getParticipantEnrollmentInfo.electedInvestments
              : [],
          sourceWiseInvestments: setSourceWiseInvestmentsInformation(
            getParticipantEnrollmentInfo
          ),
          ...getParticipantEnrollmentInfo,
          enrolledSources: enrolledSourcesInitialValues,
        }}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={formSubmit}
      >
        {(formProps) => {
          const {
            setFieldValue,
            values,
            handleChange,
            handleSubmit,
            setValues,
            setSubmitting,
            errors,
            resetForm,
            ...rest
          } = formProps;

          const sameSourceElectionArrayToRender = get(
            getParticipantEnrollmentInfo,
            "id"
          )
            ? get(values, "enrolledSources", [])
            : get(getDefaultElection, "sourceList", []);
          const onSubmit = (savedInvestments) => {
            const inv = [];
            if (values.sameSourcesInvestmentElection)
              savedInvestments.forEach((e) => {
                if (
                  values.sameSourcesInvestmentElection.some(
                    (x) => x.investmentName == e.investmentName
                  )
                )
                  return;
                inv.push(e);
              });
            else {
              inv = saveInvestments; // for the base case pageLoad
            }
            setValues({
              ...values,
              sameSourcesInvestmentElection: [
                ...values.sameSourcesInvestmentElection,
                ...inv,
              ],
            });
            setSaveInvestments([
              ...values.sameSourcesInvestmentElection,
              ...inv,
            ]);
            setModalOpen(false);
          };
          const addSourceWiseInvestments = (addedInvestments, sourceInd) => {
            var invs = [];
            const prevInvs = values.sourceWiseInvestments[sourceInd];
            if (prevInvs && prevInvs.length > 0) {
              invs = [
                ...prevInvs,
                ...addedInvestments?.filter(
                  (x) =>
                    !prevInvs
                      .map((i) => i.investmentId)
                      .includes(x.investmentId)
                ),
              ]; // case where already one or more investments are present for the source
            }
            // else if (invsPresent && !prevInvs) {
            //   invs = [ ...addedInvestments];
            // }
            else if (!prevInvs) {
              invs = addedInvestments; // case where no investments are added for a source
            }
            setValues({
              ...values,
              sourceWiseInvestments: {
                ...values.sourceWiseInvestments,
                [sourceInd]: invs,
              },
            });
            setModalOpen(false);
          };

          const Invsum1 = () => {
            let sum1 = 0;
            const sumInp = values.sameSourcesInvestmentElection;
            if (sumInp && sumInp.length > 0) {
              sumInp.forEach((i) => {
                if (i.allocationPercentage) sum1 += i.allocationPercentage;
              });
            }
            return sum1;
          };
          const Invsum2 = (sourceInd) => {
            let sum = 0;
            if (sourceInd in values.sourceWiseInvestments)
              values.sourceWiseInvestments[sourceInd].forEach((i) => {
                if (i.allocationPercentage) sum += i.allocationPercentage;
              });
            return sum;
          };
          const deletefunction = (name) => {
            const invs =
              !values.useDefaultAllocation &&
              values.doesAllSourcesFollowSameElection
                ? values.sameSourcesInvestmentElection
                : values.sourceWiseInvestments[sourceInd];

            var temp = invs.filter((e) => e.investmentName !== name);
            values.sameSourcesInvestmentElection = values.sameSourcesInvestmentElection.filter(
              (x) => x.investmentName !== name
            );
            setAddedInvestments({ [sourceInd]: temp });
            setSaveInvestments(temp);
            setValues({ ...values });
            if (
              values.doesAllSourcesFollowSameElection ===
              getParticipantEnrollmentInfo.doesAllSourcesFollowSameElection
            ) {
              //writing this to prevent enablereintialise resetting the deleted investments
              setGetParticipantEnrollmentInfo((prev) => ({
                ...prev,
                electedInvestments: values.sameSourcesInvestmentElection,
              }));
            }
            //values["ID" + name] = null;
          };
          const deleteSourceInvestment = (name, sourceInd, invInd) => {
            invInd == 0
              ? values.sourceWiseInvestments[sourceInd].shift()
              : values.sourceWiseInvestments[sourceInd].splice(invInd);
            if (values.sourceWiseInvestments[sourceInd].length == 0)
              delete values.sourceWiseInvestments.sourceInd;
            setValues({ ...values });
            setAddedInvestments({
              [sourceInd]: values.sourceWiseInvestments[sourceInd],
            });
          };
          return (
            <LoaderWrapper isLoading={loading}>
              <Form
                autoComplete="off"
                className="h-100"
                onSubmit={handleSubmit}
              >
                <div className="d-flex w-100 align-items-center justify-content-between">
                  <div className="plan-sub-heading">
                    Employee Enrollment Detail&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </div>
                  <WarningModal show={modalVisible} onHide={closeModal}>
                    <div className="remove-text">
                      <h4>Are you sure?</h4>
                      <p>
                        You will be opted out from the plan. Would you like to
                        proceed?
                      </p>
                      <Button
                        type="button"
                        className="remove-btn mr-4"
                        onClick={() => onOptClick()}
                      >
                        Yes
                      </Button>
                      <Button className="cancel-btn" onClick={closeModal}>
                        No
                      </Button>
                    </div>
                  </WarningModal>
                  <WarningInfoModal show={warningVisible} onHide={closeWarning}>
                    <p>
                      There is an active transaction against employee. Complete
                      the request to opt out of plan.
                    </p>
                    <Button onClick={closeWarning}>Ok</Button>
                  </WarningInfoModal>
                  {isEdit && !isSave ? (
                    <div className="align-center d-flex">
                      <Button
                        type="button"
                        className="add-btn"
                        variant="secondary"
                        onClick={() => setModalVisible(true)}
                        disabled={
                          getIsOptOutAccess == true || getIsOptedOut == true
                        }
                      >
                        Opt out of plan
                      </Button>
                      &nbsp; &nbsp; &nbsp;
                      <Button
                        variant="primary"
                        type="button"
                        disabled={getIsOptedOut}
                        onClick={() => {
                          if (!getIsOptedOut)
                            setTimeout(() => setNewFlow(FLOW_TYPES.SAVE), 300);
                        }}
                      >
                        Edit
                      </Button>
                    </div>
                  ) : (
                    <div className="align-center">
                      <Button
                        type="button"
                        className="add-btn"
                        variant="secondary"
                        onClick={() => {
                          resetForm();
                          setNewFlow(FLOW_TYPES.EDIT);
                        }}
                      >
                        Cancel
                      </Button>
                      &nbsp;
                      <Button
                        type="submit"
                        className="add-btn"
                        variant="primary"
                      >
                        Save
                      </Button>
                    </div>
                  )}
                </div>

                {getIsOptedOut == true && (
                  <div className="enrollment-defferal">
                    <FontAwesomeIcon
                      icon={faInfoCircle}
                      style={{
                        marginTop: "2px",
                        marginRight: "10px",
                        color: "#307BF6",
                      }}
                    />
                    <p className="enrollment-style">
                      {`You have been opted Out of the Plan`}
                    </p>
                  </div>
                )}

                <p className="font-weight-500 text-black">Deferral Election</p>

                <Field
                  isRequired
                  name={fields.useDefaultElection}
                  label="Use plan default deferral election"
                  size="sm"
                  onClick={() => {}}
                  options={yesNoOptions}
                  selectedValue={values[fields.useDefaultElection]}
                  onChange={(value) => {
                    setFieldValue(fields.useDefaultElection, value);
                    if (!value)
                      setFieldValue(
                        "enrolledSources",
                        values["enrolledSources"].map((_) => {
                          return { ..._, election: "" };
                        })
                      );
                    else if (
                      value &&
                      getParticipantEnrollmentInfo?.useDefaultElection
                    )
                      setFieldValue(
                        "enrolledSources",
                        enrolledSourcesInitialValues
                      );
                    else
                      setFieldValue(
                        "enrolledSources",
                        sourcesList
                          .filter((x) => x.sourceType == 1)
                          .map((_) => {
                            return {
                              ..._,
                              election: get(
                                getDefaultElection,
                                "sourceList",
                                []
                              ).find(
                                (i) => i.sourceContributionId === _.sourceId
                              )?.contributionRate,
                            };
                          })
                      );
                  }}
                  disabled={isEdit && !isSave}
                  component={FieldButtonGroup}
                />

                {values[fields.useDefaultElection] === true
                  ? sameSourceElectionArrayToRender.map((e, i) => {
                      const FieldContributionType =
                        e.contributionType === 2 ||
                        sourcesList.find((_) => _.sourceId == e.sourceId)
                          ?.contributionType == "Dollar"
                          ? FieldInputDollar
                          : FieldInputPercentage;
                      const valueOfField = e.contributionRate ?? e.election;
                      return (
                        <div key={i}>
                          <Field
                            key={i}
                            size="xs"
                            isRequired
                            name={e.sourceName}
                            label={e.sourceName}
                            value={valueOfField}
                            disabled={true}
                            component={FieldContributionType}
                            type="number"
                            autoComplete="off"
                          />
                        </div>
                      );
                    })
                  : null}

                {values[fields.useDefaultElection] === false ? (
                  <FieldArray name="enrolledSources">
                    {(fieldArrayProps) =>
                      values["enrolledSources"].map((e, i) => {
                        const fieldName = "enrolledSources[" + i + "].election";
                        const DScontrolType =
                          e.contributionType === `Dollar`
                            ? FieldInputDollar
                            : FieldInputPercentage;
                        const minMaxDescription =
                          e.contributionType === `Dollar`
                            ? "Minimum $" +
                              e.limitMinimumDollar +
                              " / " +
                              "Maximum $" +
                              e.limitMaximumDollar
                            : "Minimum " +
                              e.limitMinimumDollar +
                              "% / " +
                              "Maximum " +
                              e.limitMaximumDollar +
                              "%";
                        return (
                          <div key={i}>
                            <Field
                              size="xs"
                              isRequired
                              name={fieldName}
                              label={e.sourceName}
                              hasSuggestion
                              suggestionDefaultText={minMaxDescription}
                              shouldDisplaySuggestion
                              component={DScontrolType}
                              type="number"
                              autoComplete="off"
                              onChange={(e) => handleChange(e)}
                              disabled={isEdit && !isSave}
                            />
                          </div>
                        );
                      })
                    }
                  </FieldArray>
                ) : null}

                <p className="font-weight-500 text-black">
                  Investment Election
                </p>
                <Field
                  isRequired
                  name={fields.useDefaultAllocation}
                  label="Use plan default investment election"
                  size="sm"
                  options={yesNoOptions}
                  selectedValue={returnOnlyIfBoolean(
                    values[fields.useDefaultAllocation]
                  )}
                  onChange={(value) => {
                    setFieldValue("sourceWiseInvestments", []);
                    setFieldValue(fields.useDefaultAllocation, value);
                  }}
                  disabled={isEdit && !isSave}
                  component={FieldButtonGroup}
                />

                {values[fields.useDefaultAllocation] === true ? (
                  <div className="mt-40 table-size">
                    <div>
                      <Table>
                        <Table.Thead>
                          <Table.Tr>
                            {columns.map((item, index) => {
                              return (
                                <Table.Th
                                  key={index}
                                  className={(item.className, "col-md-5")}
                                >
                                  {item.label}
                                </Table.Th>
                              );
                            })}
                          </Table.Tr>
                        </Table.Thead>
                        <Table.Tbody>
                          {getDefaultElection &&
                            getDefaultElection.investmentDetails &&
                            getDefaultElection.investmentDetails.map(
                              (source, index) => {
                                return (
                                  <Table.Tr key={index} className="">
                                    <Table.Td className="column-investment col-md-5">
                                      {source.investmentName}
                                    </Table.Td>
                                    <Table.Td className="column-percentage">
                                      <Form
                                        autoComplete="off"
                                        className="h-100 percentage-field"
                                      >
                                        <Field
                                          size="xs"
                                          isRequired
                                          name="employeeTax"
                                          hasSuggestion
                                          shouldDisplaySuggestion
                                          value={source.investmentPercentage}
                                          disabled={true}
                                          component={FieldInputPercentage}
                                          type="number"
                                          autoComplete="off"
                                        />
                                      </Form>
                                    </Table.Td>
                                  </Table.Tr>
                                );
                              }
                            )}
                        </Table.Tbody>
                        <div className="line-separator-total" />
                        <Table.Tbody>
                          <Table.Tr>
                            <Table.Td className="column-investment col-md-5">
                              Total
                            </Table.Td>
                            <Table.Td className="column-percentage col-md-5">
                              <Form
                                autoComplete="off"
                                className="h-100 percentage-field"
                              >
                                <Field
                                  size="xs"
                                  isRequired
                                  name="totalBox"
                                  hasSuggestion
                                  shouldDisplaySuggestion
                                  component={FieldInputPercentage}
                                  type="number"
                                  value={Invsum()}
                                  autoComplete="off"
                                  disabled
                                />
                              </Form>
                            </Table.Td>
                          </Table.Tr>
                        </Table.Tbody>
                      </Table>
                    </div>
                  </div>
                ) : null}

                {values[fields.useDefaultAllocation] === false ? (
                  <div>
                    <Field
                      isRequired
                      name={fields.doesAllSourcesFollowSameElection}
                      label="Does All Sources Follow Same Election"
                      size="sm"
                      options={yesNoOptions}
                      ref={doesAllSourcesFollowSameElection}
                      selectedValue={
                        values[fields.doesAllSourcesFollowSameElection]
                      }
                      onChange={(value) => {
                        setAddedInvestments({ 0: [] });
                        doesAllSourcesFollowSameElection.current = value;
                        setValues({
                          ...values,
                          sourceWiseInvestments: {},
                          sameSourcesInvestmentElection: [],
                          doesAllSourcesFollowSameElection: value,
                        });
                      }}
                      disabled={isEdit && !isSave}
                      component={FieldButtonGroup}
                    />
                    {values[fields.doesAllSourcesFollowSameElection] ? (
                      //!isEmpty(getDefaultElection?.investmentDetails) ||
                      !isEmpty(saveInvestments) ? (
                        <div className="mt-40 table-size">
                          <div className="d-flex justify-content-between align-baseline">
                            <p className="mt-20 plan-heading-plan">
                              List of Investment Election Added
                            </p>
                            <Button
                              variant="secondary"
                              onClick={() => setModalOpen(true)}
                            >
                              Add Investment
                            </Button>
                          </div>
                          <div>
                            <FieldArray name="investmentList">
                              {(fieldArrayProps) => (
                                <Table>
                                  <Table.Thead>
                                    <Table.Tr>
                                      {columns.map((item, index) => {
                                        return (
                                          <Table.Th
                                            key={index}
                                            className={
                                              (item.className, "col-md-4")
                                            }
                                          >
                                            {item.label}
                                          </Table.Th>
                                        );
                                      })}
                                    </Table.Tr>
                                  </Table.Thead>
                                  <Table.Tbody>
                                    {saveInvestments.map((source, index) => {
                                      const fieldName =
                                        "sameSourcesInvestmentElection[" +
                                        index +
                                        "].allocationPercentage";
                                      //"ID" + source.investmentName;
                                      return (
                                        <Table.Tr key={index}>
                                          <Table.Td className="column-investment col-md-4">
                                            {source.investmentName}
                                          </Table.Td>
                                          <Table.Td className="column-percentage">
                                            <Form
                                              autoComplete="off"
                                              className="h-100 percentage-field"
                                            >
                                              <Field
                                                size="xs"
                                                isRequired
                                                name={fieldName}
                                                hasSuggestion
                                                shouldDisplaySuggestion
                                                component={FieldInputPercentage}
                                                type="number"
                                                value={get(values, fieldName)}
                                                //defaultValue={get(values, fieldName)}
                                                onChange={handleChange}
                                                disabled={isEdit && !isSave}
                                                autoComplete="off"
                                                validate={(value) =>
                                                  [
                                                    "",
                                                    undefined,
                                                    null,
                                                    "Select One",
                                                  ].includes(value)
                                                    ? "Required"
                                                    : null
                                                }
                                              />
                                            </Form>
                                          </Table.Td>
                                          <Table.Td className="column-action col-md-4">
                                            <Link>
                                              <FontAwesomeIcon
                                                icon={faTrashAlt}
                                                color="red"
                                                onClick={() =>
                                                  deletefunction(
                                                    source.investmentName
                                                  )
                                                }
                                              />
                                            </Link>
                                          </Table.Td>
                                        </Table.Tr>
                                      );
                                    })}
                                  </Table.Tbody>

                                  <div className="line-separator-total" />
                                  <Table.Tbody>
                                    <Table.Tr>
                                      <Table.Td className="column-investment col-md-4">
                                        Total
                                      </Table.Td>
                                      <Table.Td className="column-percentage col-md-4">
                                        <Form
                                          autoComplete="off"
                                          className="h-100 percentage-field"
                                        >
                                          <Field
                                            size="xs"
                                            isRequired
                                            name="totalBox"
                                            hasSuggestion
                                            shouldDisplaySuggestion
                                            component={FieldInputPercentage}
                                            type="number"
                                            value={Invsum1()}
                                            autoComplete="off"
                                            disabled
                                            validate={() =>
                                              Invsum1() != 100 ? ` ` : undefined
                                            }
                                          />
                                          <div className="error-message-deferral">
                                            {Invsum1() != 100
                                              ? `The total value of investment election should be 100%`
                                              : ``}
                                          </div>
                                        </Form>
                                      </Table.Td>
                                    </Table.Tr>
                                  </Table.Tbody>
                                </Table>
                              )}
                            </FieldArray>
                          </div>
                        </div>
                      ) : (
                        <div className="mt-40">
                          <p className="mt-20 plan-heading-plan">
                            Investment Election
                          </p>
                          <AddPlans
                            content="No Investments added."
                            buttonLabel="Add Investment"
                            onPrimaryClick={onViewButtonClick}
                          />
                          <div className="error-message-deferral">
                            {errors?.sameElectionInvestment}
                          </div>
                        </div>
                      )
                    ) : (
                      <>
                        {values[fields.doesAllSourcesFollowSameElection] ===
                        false ? (
                          <div>
                            {sourcesList.map((s, i) => {
                              return (
                                // remove inline styling
                                <div className="mt-40 table-size">
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      marginBottom: "-15px",
                                    }}
                                  >
                                    <p className="mt-20 plan-heading-plan">
                                      {s.sourceName}
                                    </p>
                                    {!isEmpty(
                                      values.sourceWiseInvestments?.[i]
                                    ) ? (
                                      <Button
                                        variant="secondary"
                                        disabled={isEdit && !isSave}
                                        style={{ height: "40px" }}
                                        onClick={() => {
                                          setSourceInd(i);
                                          setModalOpen(true);
                                        }}
                                      >
                                        Add Investment
                                      </Button>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                  {/* <div className="d-flex justify-content-between align-baseline">
                              List of Investment Election Added
                              </div> */}
                                  {isEmpty(
                                    values.sourceWiseInvestments?.[i]
                                  ) ? (
                                    <div className="mt-40">
                                      <p className="mt-20 plan-heading-plan">
                                        List of Investment Election Added
                                      </p>
                                      <AddPlans
                                        content="No Investments added."
                                        buttonLabel="Add Investment"
                                        onPrimaryClick={() => {
                                          setSourceInd(i);
                                          onViewButtonClick();
                                        }}
                                        disabled={isEdit && !isSave}
                                      />
                                      <div className="error-message-deferral">
                                        {get(
                                          errors,
                                          `differentElectionInvestment.${i}`
                                        )}
                                      </div>
                                    </div>
                                  ) : (
                                    <div>
                                      <FieldArray name="investmentList">
                                        {(fieldArrayProps) => (
                                          <Table>
                                            <Table.Thead>
                                              <Table.Tr>
                                                {columns.map((item, index) => {
                                                  return (
                                                    <Table.Th
                                                      key={index}
                                                      className={
                                                        (item.className,
                                                        "col-md-4")
                                                      }
                                                    >
                                                      {item.label}
                                                    </Table.Th>
                                                  );
                                                })}
                                              </Table.Tr>
                                            </Table.Thead>
                                            <Table.Tbody>
                                              {values.sourceWiseInvestments[
                                                i
                                              ]?.map((source, index) => {
                                                const fieldName =
                                                  "sourceWiseInvestments[" +
                                                  i +
                                                  "][" +
                                                  index +
                                                  "].allocationPercentage";

                                                return (
                                                  <Table.Tr key={index}>
                                                    <Table.Td className="column-investment col-md-4">
                                                      {source.investmentName}
                                                    </Table.Td>
                                                    <Table.Td className="column-percentage">
                                                      <Form
                                                        autoComplete="off"
                                                        className="h-100 percentage-field"
                                                      >
                                                        <Field
                                                          size="xs"
                                                          isRequired
                                                          name={fieldName}
                                                          hasSuggestion
                                                          shouldDisplaySuggestion
                                                          component={
                                                            FieldInputPercentage
                                                          }
                                                          type="number"
                                                          value={get(
                                                            values,
                                                            fieldName
                                                          )}
                                                          //defaultValue={get(values, fieldName)}
                                                          onChange={
                                                            handleChange
                                                          }
                                                          disabled={
                                                            isEdit && !isSave
                                                          }
                                                          autoComplete="off"
                                                          validate={(value) =>
                                                            [
                                                              "",
                                                              undefined,
                                                              null,
                                                              "Select One",
                                                            ].includes(value)
                                                              ? "Required"
                                                              : null
                                                          }
                                                        />
                                                      </Form>
                                                    </Table.Td>
                                                    <Table.Td className="column-action col-md-4">
                                                      <Link>
                                                        <FontAwesomeIcon
                                                          icon={faTrashAlt}
                                                          color="red"
                                                          onClick={() =>
                                                            deleteSourceInvestment(
                                                              source.investmentName,
                                                              i,
                                                              index
                                                            )
                                                          }
                                                        />
                                                      </Link>
                                                    </Table.Td>
                                                  </Table.Tr>
                                                );
                                              })}
                                            </Table.Tbody>

                                            <div className="line-separator-total" />
                                            <Table.Tbody>
                                              <Table.Tr>
                                                <Table.Td className="column-investment col-md-4">
                                                  Total
                                                </Table.Td>
                                                <Table.Td className="column-percentage col-md-4">
                                                  <Form
                                                    autoComplete="off"
                                                    className="h-100 percentage-field"
                                                  >
                                                    <Field
                                                      size="xs"
                                                      isRequired
                                                      name={`totalBox.${i}`}
                                                      hasSuggestion
                                                      shouldDisplaySuggestion
                                                      component={
                                                        FieldInputPercentage
                                                      }
                                                      type="number"
                                                      value={Invsum2(i)}
                                                      autoComplete="off"
                                                      disabled
                                                      validate={(value) =>
                                                        Invsum2(i) != 100
                                                          ? ` `
                                                          : undefined
                                                      }
                                                    />
                                                    <div className="error-message-deferral">
                                                      {Invsum2(i) != 100
                                                        ? `The total value of investment election should be 100%`
                                                        : ``}
                                                    </div>
                                                  </Form>
                                                </Table.Td>
                                              </Table.Tr>
                                            </Table.Tbody>
                                          </Table>
                                        )}
                                      </FieldArray>
                                    </div>
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        ) : null}
                      </>
                    )}
                  </div>
                ) : null}

                <SliderPanel isOpen={isModalOpen} size="35" showCancel={false}>
                  <div className="d-flex justify-content-between align-baseline">
                    <div>
                      <p className="plan-heading-plan">Plan Investments</p>
                      <p className="enrollment-sub-heading">
                        {filteredResponse?.[sourceInd]?.length} Investments
                        Available
                      </p>
                    </div>
                    <div>
                      <Button
                        variant="secondary"
                        onClick={() => {
                          setModalOpen(false);
                          let tempAddedInv = { ...addedInvestments };
                          tempAddedInv[sourceInd] = get(
                            values,
                            `sourceWiseInvestments.${sourceInd}`,
                            {}
                          );
                          setAddedInvestments(tempAddedInv);
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="primary"
                        onClick={() =>
                          !values.useDefaultAllocation &&
                          values.doesAllSourcesFollowSameElection
                            ? onSubmit(addedInvestments[sourceInd])
                            : addSourceWiseInvestments(
                                addedInvestments[sourceInd],
                                sourceInd
                              )
                        }
                        className="ml-4"
                      >
                        Save
                      </Button>
                    </div>
                  </div>
                  <div className="search-bar-investment">
                    <InputGroup>
                      <FormControlSearch
                        size="lg"
                        id="plan-search-box"
                        className="plan-search-box"
                        type="search"
                        autoComplete="off"
                        placeholder="Search Investment"
                        onChange={(e) => setSearchString(e.target.value)}
                      />
                    </InputGroup>
                  </div>
                  <p className="enrollment-side-content">
                    {filteredResponse?.[sourceInd]?.length} Investments
                    Available
                  </p>

                  <div className="scroll-body">
                    {filteredResponse?.[sourceInd] &&
                      filteredResponse[sourceInd].map((e, i) => (
                        <div className="d-flex justify-content-between">
                          <p>{e.investmentName}</p>
                          {addedInvestments?.[sourceInd]?.find(
                            (y) => y.investmentName === e.investmentName
                          ) ? (
                            <Button
                              size="sm"
                              style={{
                                width: "75px",
                                margin: "0px 0px 8px 0px",
                              }}
                              variant="secondary"
                              disabled
                              classname="custom-added"
                            >
                              Added
                            </Button>
                          ) : (
                            <>
                              <Button
                                style={{
                                  width: "75px",
                                  margin: "0px 0px 8px 0px",
                                }}
                                variant="secondary"
                                onClick={() =>
                                  addInvestmentsAndSourceIdToPlan(e)
                                }
                              >
                                Add
                              </Button>
                            </>
                          )}
                        </div>
                      ))}
                  </div>
                </SliderPanel>

                <Field
                  isRequired
                  name={fields.autoDeferralIncrease}
                  label="Auto Deferral Increase"
                  size="sm"
                  options={yesNoOptions}
                  selectedValue={returnOnlyIfBoolean(
                    values[fields.autoDeferralIncrease]
                  )}
                  onChange={(value) => {
                    setFieldValue(fields.autoDeferralIncrease, value);
                  }}
                  disabled={isEdit && !isSave}
                  component={FieldButtonGroup}
                />
              </Form>
            </LoaderWrapper>
          );
        }}
      </Formik>
    </div>
  );
};

export default ManualEnrollmentContainer;
